<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: p_fy
 * @LastEditTime: 2019-07-18 20:52:35
 * @Description: 罐区仓库需求详情信息。
 -->
<!--  详情显示页面  -->
<template>
  <div class="demand-item-details">
    <div class="base-info">
      <div>基本信息</div>
      <ul>
        <li :title="demand.companyName">
          <span>公司名称</span> {{ demand.companyName }}
        </li>
        <li :title="demand.storageLocationLabel">
          <span>库房位置</span> {{ demand.storageLocationLabel }}
        </li>
        <li :title="demand.tankTypeLabel">
          <span>货物类型</span> {{ demand.tankTypeLabel }}
        </li>
        <li :title="`${demand.expectPrice} 元/罐/天`">
          <span>期望租金</span> {{ demand.expectPrice }} 元/罐/天
        </li>
        <li :title="demand.leaseStartTime">
          <span>租赁开始日期</span> {{ demand.leaseStartTime }}
        </li>
        <li :title="demand.leaseEndTime">
          <span>租赁结束日期</span> {{ demand.leaseEndTime }}
        </li>
        <li :title="demand.fireQualificationLabel">
          <span>消防资质</span> {{ demand.fireQualificationLabel }}
        </li>
        <li :title="demand.fireResistanceRatingLabel">
          <span>罐区耐火等级</span> {{ demand.fireResistanceRatingLabel }}
        </li>
      </ul>
    </div>
    <div class="contact-info">
      <div>联系人</div>
      <ul>
        <li>
          <span>联系人</span> {{ demand.linkMan }}
        </li>
        <li>
          <span>联系电话</span> {{ demand.telephone }}
        </li>
      </ul>
    </div>
    <div class="imgs-info">
      <div>图片</div>
      <ul v-if="cargoUrl(demand)" v-viewer>
        <li v-for="(item , index) in cargoUrl(demand)" :key="index">
          <img :src="item | getImg" onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;">
        </li>
      </ul>
      <div>备注</div>
      <span>{{ demand.remarks }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TankDemandInfo',
  props: {
    demand: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    cargoUrl(demand) { // 图片回调
      return (demand) => {
        if (demand.cargoUrl == null || demand.cargoUrl == '') {
          return false
        }
        return demand.cargoUrl.split(',').filter(n => n) // 数组去空
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$perfix: "demand-item";
$main-color: rgb(190, 35, 22);
@keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    position: relative;
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        ul {
          columns: 4;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      &.contact-info {
        ul {
          width: 50%;
          columns: 2;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 7px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      &.imgs-info {
        // word-wrap: break-word;
        word-break: break-all;
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            img {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
</style>
